export function localStorageEnabled(): boolean {
    const key = 'bek-dvd-enabled';
    try {
        if (window.localStorage) {
            window.localStorage.setItem(key, 'true');
            const got = window.localStorage.getItem(key);
            window.localStorage.removeItem(key);
            if (got === 'true') {
                return true;
            }
        }
        return false;
    } catch (err) {
        // Accessing localStorage will throw an error if it's not enabled.
        return false;
    }
}